import { render, staticRenderFns } from "./Testimonialr.vue?vue&type=template&id=72e8d7bc&"
import script from "./Testimonialr.vue?vue&type=script&lang=js&"
export * from "./Testimonialr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports